<template>
    <el-dialog title="物料选择" :visible.sync="DialogVisible" width="80%" @close="machineAddDialogClosed"
        :close-on-click-modal="false">

        <d-query-input style="padding-bottom: 10px;" :options="options" @query="queryBySelect" @clear="clearQuery"
            width="340px" :pageInfo="pageInfo" />

        <el-row :gutter="10">
            <!--liuqy 去掉胚布，这里只需要原料 -->
            <!--            <el-col span="2">
					<div class="col-title">物料分组</div>
					<div style="height:100px; display:flex; flex-direction:column; justify-content:space-evenly; align-items:left;">
						<div> 
							<el-button type="primary" @click="getWuLiaoList(1, 'PB')" size="mini" icon="el-icon-circle-plus">胚布
							</el-button>
						</div>
						<div> 
							<el-button type="primary" @click="getWuLiaoList(1, 'YL')" size="mini" icon="el-icon-circle-plus">原料
							</el-button>
						</div>
					</div>
				</el-col> -->

            <el-col span="6">
                <div class="col-title">选择原料</div>
                <div class="col-body">
                    <el-table highlight-current-row @row-click="yuanLiaoRowClick" :data="responseData"
                        :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}" border stripe
                        id="XXXX">

                        <el-table-column prop="local_id" label="行" align="center" width="35px">
                        </el-table-column>

                        <el-table-column prop="number" label="物料编号" align="center" width="120px">
                        </el-table-column>

                        <el-table-column prop="name" label="物料名称" align="center">
                        </el-table-column>

                    </el-table>
                </div>

                <el-pagination style="text-align: center" background layout="prev, pager, next"
                    @current-change="handleCurrentChange" :page-size="pageInfo.size" :current-page="pageInfo.page"
                    :page-count="totalPages">
                </el-pagination>
            </el-col>


            <el-col span="6">
                <div class="col-title">选择规格</div>
                <div class="col-body">
                    <el-table highlight-current-row @row-click="guiGeRowClick" :data="this.display_specItems"
                        :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}" border stripe
                        id="XXXX">
                        <el-table-column prop="lineNo" label="行" align="center" width='35px'>
                        </el-table-column>

                        <el-table-column prop="specNumber" label="规格编号" align="center" width="120px">
                        </el-table-column>

                        <el-table-column prop="specName" label="规格名称" align="center">
                        </el-table-column>

                    </el-table>
                </div>
            </el-col>

            <el-col span="2" style="height:400px;" class="rzy-vert-center">
                <div class="rzy-toolbar-v" style="height:100px;">
                    <el-button type="primary" @click="addWuLiaoList()" size="mini">添加</el-button>
                    <el-button type="primary" @click="delWuLiaoList()" size="mini">删除</el-button>
                </div>
            </el-col>

            <el-col span="6">
                <div class="col-title">已选物料</div>
                <div class="col-body">
                    <el-table highlight-current-row @row-click="guiSelectYuanliaoRow" :data="this.selectedWuLiaoList"
                        :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}" border stripe
                        id="XXXX">
                        <el-table-column prop="name" label="物料名称" align="center">
                        </el-table-column>
                        <el-table-column prop="specName" label="规格名称" align="center">
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
        </el-row>



        <div slot="footer">
            <el-button type="" @click="cancel()">取消</el-button>
            <el-button type="primary" @click="onSubmit()">确定</el-button>
        </div>


    </el-dialog>
</template>

<script>
    import * as api from '@/api/factory/machine/list/add'
    import {
        dQueryInput
    } from "@/components/projectComponents";

    export default {
        components: {
            dQueryInput
        },
        data() {
            var lengthruler = (rules, value, cb) => {
                const ruler = /(^[1-9]([0-9]*)$|^[1-9]$)/
                if (ruler.test(value)) {
                    return cb()
                }
                cb(new Error('请输入大于0的正整数'))
            }
            return {
                DialogVisible: false,
                responseData: [
                    // 调试用假数据--正式版注释掉
                    // {
                    //     number: '测试1',
                    //     name: '测试1',
                    // },
                ],
                display_specItems: null,

                selectYuanLiaoId: 0, //当前 选择原料的 id
                selectGuiGeId: 0, //当前 选择规格的 id

                selectedWuLiaoList: [], //已选物料
                selectedWuLiaoId: 0, //已选物料id
                selectedWuLiaoRow: null,

                //分页相关--sta
                pageInfo: {
                    page: 1,
                    size: 10,
                    kind: 'PB', //胚布 = PB, 原料 = YL。
                    //下面是 隐藏的 查询参数--sta
                    number: null, //胚布编号
                    name: null, //胚布名称
                    //下面是 隐藏的 查询参数--end
                },
                totalPages: 0,
                //分页相关--end

                // 查询--sta
                options: [{
                        label: "物料编号",
                        value: "number",
                    },
                    {
                        label: "物料名称",
                        value: "name",
                    },
                ],
                // 查询--end

            }
        },
        methods: {
            // 外部调用，显示添加机台弹框
            show() {
                this.DialogVisible = true

                //显示对话框 时候 要加载数据
                this.getWuLiaoList(1, 'YL')
                //已选 物料 必须清空
                this.selectedWuLiaoList = [];
            },
            // 外部调用，取 “已选物料” 列表
            getWuLiaoListFromDialg() {
                return this.selectedWuLiaoList
            },

            // 监听回车按钮
            keyCodeListen() {
                // const code = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode
                const code = event.keyCode
                if (code === 13) this.onSubmit()
            },
            // 点击 确定 按钮
            onSubmit() {
                this.$emit('update') //触发 回调的 update函数???
                this.DialogVisible = false
            },
            // 点击取消按钮触发
            cancel() {
                this.DialogVisible = false
            },
            mounted() {
                document.addEventListener('keyup', this.keyCodeListen)
            },
            destroyed() {
                document.removeEventListener('keyup', this.keyCodeListen)
            },


            // 获取 胚布+原料 分页列表
            getWuLiaoList(val, kind) {
                if (kind === undefined) { //选中 超过1 的页数。
                    // this.pageInfo.kind = XXX     不需要改变kind.
                } else { //选中 第1页。
                    this.pageInfo.kind = kind
                }

                //---------------------
                this.pageInfo.page = val

                this.$requestBase({
                    url: 'v1/material/list',
                    method: 'get',
                    params: this.pageInfo
                }).then(res => {
                    this.responseData = this.formatResponse(res.data.list)

                    //初始化 '选择规格'
                    // console.log('this.responseData[0].specItems=', this.responseData[0].specItems)
                    if (this.responseData != undefined) {
                        if (this.responseData[0].specItems != undefined) {
                            this.display_specItems = this.responseData[0].specItems

                            //手动增加行号
                            for (let i = 0; i < this.display_specItems.length; i++) {
                                this.display_specItems[i].lineNo = i + 1
                            }
                        }
                    }

                    this.totalPages = res.data.pages
                })
            },
            // 格式化 胚布+原料 列表
            formatResponse(response) {
                response.forEach((item, index) => {
                    item.local_id = index + 1
                    item.createTime = this.utils.timestampToTime(item.createTime, 2)
                })
                return response
            },

            //"选择原料" 单击一行
            yuanLiaoRowClick(row, event, column) {
                // console.log('row=', row)
                // console.log('event=', event)
                // console.log('column=', column)
                // console.log('row.local_id=', row.local_id)
                this.selectYuanLiaoId = row.local_id

                //"选择原料"行 变化时候，"选择规格" 内容要变化。
                this.display_specItems = this.responseData[row.local_id - 1].specItems
                //手动增加行号
                for (let i = 0; i < this.display_specItems.length; i++) {
                    this.display_specItems[i].lineNo = i + 1
                }
            },

            //"选择规格" 单击一行
            guiGeRowClick(row, event, column) {
                // console.log('row=', row)
                // console.log('event=', event)
                // console.log('column=', column)
                // console.log('row.lineNo=', row.lineNo)
                this.selectGuiGeId = row.lineNo
            },
            //选择物料 单击
            guiSelectYuanliaoRow(row, event, column) {
                this.selectedWuLiaoRow = row

                console.log('row=', row)
                console.log('event=', event)
                console.log('column=', column)

            },

            //添加到 已选物料
            addWuLiaoList() {
                if ((this.selectYuanLiaoId === 0) || (this.selectGuiGeId === 0)) {
                    this.$Message.closeAll()
                    this.$Message.success('还未选择 或者 原料表/规格表 为空，无法添加。')
                } else {
                    this.selectedWuLiaoList.push({
                        materialId: this.responseData[this.selectYuanLiaoId - 1].id, //物料ID
                        name: this.responseData[this.selectYuanLiaoId - 1].name, //物料名称
                        number: this.responseData[this.selectYuanLiaoId - 1].number, //物料编号
                        //-----------------------
                        specId: this.responseData[this.selectYuanLiaoId - 1].specItems[this.selectGuiGeId - 1]
                            .id, //规格ID
                        specName: this.responseData[this.selectYuanLiaoId - 1].specItems[this.selectGuiGeId - 1]
                            .specName, //规格名称
                        specNumber: this.responseData[this.selectYuanLiaoId - 1].specItems[this.selectGuiGeId -
                            1].specNumber, //规格编号
                    })
                }
            },

            //从 ‘已选物料’ 删除
            delWuLiaoList() {
                if (this.selectedWuLiaoRow === null) {
                    return
                }
                console.log('selectedWuLiaoRow=', this.selectedWuLiaoRow)
                console.log('selectedWuLiaoList b=', this.selectedWuLiaoList)
                // this.selectedWuLiaoList.
                console.log('selectedWuLiaoList f=', this.selectedWuLiaoList)
            },

            // 分页切换
            handleCurrentChange(newNum) {
                this.getWuLiaoList(newNum)
            },

            // 条件查询
            queryBySelect(pageInfo) {
                this.pageInfo = pageInfo;
                this.getWuLiaoList(1);
            },
            // 清空条件查询
            clearQuery(pageInfo) {
                this.pageInfo = pageInfo;
                this.getWuLiaoList(1);
            },

        }
    }
</script>

<style lang="scss" scoped>
    .col-title {
        padding: 5px 0px;
        font-weight: bold;
    }

    .col-body {
        height: 400px;
        border: 1px solid #ccc;
        padding: 0px;
    }
</style>